export class RecallClass {
    id: number;
    RecallClassName: string;
    status: boolean;
}